import { dayjs, get, toNumber } from "~/utils/helpers";
import type { GetCalendarDateListParam } from "./../../services/model/calendar/date-list";
import { type MaybeRefOrGetter, AnyFn, toValue } from "@vueuse/core";
import useRequest from "~/composables/useRequest";
import { getCalendarDateList } from "~/services/product";
import { useRouteQuery } from "@/composables/router";
export function useCruiseCalendarDateList(
  param: MaybeRefOrGetter<GetCalendarDateListParam>,
  options: {
    isDistributor?: MaybeRefOrGetter<boolean>;
    onChange?: AnyFn;
  } = {}
) {
  const { state, execute, isReady } = useRequest(
    () => getCalendarDateList(toValue(param)),
    {
      travel: [],
    },
    {
      resetOnExecute: false,
      immediate: false,
    }
  );

  const getDateStockData = (date: Date) => {
    const _curr = state.value.travel.find((item) =>
      dayjs(item.date).isSame(date, "day")
    );
    return {
      price: get(
        _curr,
        toValue(options.isDistributor) ? "min_th_price" : "min_sale_price",
        0
      ),
      count: toNumber(get(_curr, "total_product", 0)),
      date: get(_curr, "date", ""),
    };
  };
  const date = useRouteQuery<string>("d", () =>
    get(state.value, ["travel", 0, "date"], "")
  );
  // const date = useRouteQuery<string>("d", '');

  const onPickDate = (_date: string) => {
    date.value = _date;
  };

  return {
    state,
    execute,
    isReady,
    date,
    getDateStockData,
    onPickDate,
  };
}
